export function useOgImage(ogImageArg?: string) {
  const ogImage = computed(() => {
    return ogImageArg ?? '/img/ogp_logo.png';
  });

  return {
    ogImage,
  };
}
